<template>
  <div class="w-100">
    <div class="ga-container pb-4 z-index-1038">
      <div class="rounded-6 bg-white border-form box-shadow-light-aff">
        <div class="d-flex mb-3 px-3 py-2-5 bg-green-alpha border-b-form align-items-center justify-content-between">
          <div class="text-center">
            <p class="mb-0 body-3">Check-in</p>
            <p class="mb-0 text-14 font-lato">{{$formatDateWithoutMonth(getBeFilter().date.check_in)}}</p>
          </div>
          <div class="text-center">
            <p class="mb-0 text-12 font-lato">{{ `${totalNight} ${$pluralWord(totalNight, 'night')}` }}</p>
            <svg height="13" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.0926 7.38514C18.0926 7.14157 17.9952 6.91748 17.8004 6.73237L11.3408 0.292288C11.1264 0.0779435 10.9218 0 10.688 0C10.2106 0 9.84034 0.350746 9.84034 0.837891C9.84034 1.07172 9.91832 1.29581 10.0742 1.45169L12.2566 3.67309L16.1245 7.20003L16.3194 6.71288L13.1822 6.51802H0.857379C0.350746 6.51802 0 6.87852 0 7.38514C0 7.89178 0.350746 8.25227 0.857379 8.25227H13.1822L16.3194 8.05741L16.1245 7.58001L12.2566 11.0972L10.0742 13.3186C9.91832 13.4647 9.84034 13.6986 9.84034 13.9324C9.84034 14.4196 10.2106 14.7703 10.688 14.7703C10.9218 14.7703 11.1264 14.6826 11.3213 14.4975L17.8004 8.03792C17.9952 7.85281 18.0926 7.62872 18.0926 7.38514Z" fill="#777" />
            </svg>
          </div>
          <div class="text-center">
            <p class="mb-0 body-3">Check-out</p>
            <p class="mb-0 text-14 font-lato">{{$formatDateWithoutMonth(getBeFilter().date.check_out)}}</p>
          </div>
        </div>
        
        <!-- ROOM -->
        <PerRoomCart 
          v-if="isMerchantMaldiveOhip"
          @register-tr-ref="setTransportRouteRef"
          @adjustPax="onBack('adjustPax', {
            room_rate: $event,
            valdiateAgeChild: false
          })"
        />
        <template v-else>
          <div
            class="w-100 mb-3 pb-2 px-3"
            v-for="(room_rate, rr_index) in getBeCart().room_rate_details">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <p class="w-100 mb-0 body-2-4 text-truncate cursor-pointer">{{room_rate.room_rate.name}}</p>
              <svg v-b-tooltip="'Remove Room'" class="cursor-pointer" @click="removeRoomRate(room_rate)" height="20" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.96216 14.3925C4.67027 14.3925 4.48316 14.2204 4.46819 13.936L4.24366 5.69563C4.23617 5.41871 4.42328 5.23908 4.72266 5.23908C4.99958 5.23908 5.19418 5.41123 5.20166 5.68815L5.44116 13.936C5.44865 14.2129 5.25405 14.3925 4.96216 14.3925ZM7.24494 14.3925C6.953 14.3925 6.75093 14.2129 6.75093 13.936V5.69563C6.75093 5.41871 6.953 5.23908 7.24494 5.23908C7.53681 5.23908 7.74636 5.41871 7.74636 5.69563V13.936C7.74636 14.2129 7.53681 14.3925 7.24494 14.3925ZM9.53514 14.3925C9.24327 14.3925 9.04867 14.2129 9.05614 13.936L9.28817 5.69563C9.29564 5.41123 9.49024 5.23908 9.76717 5.23908C10.0665 5.23908 10.2536 5.41871 10.2462 5.69563L10.0216 13.936C10.0067 14.2204 9.81954 14.3925 9.53514 14.3925ZM3.95925 3.42037H5.14927V1.81871C5.14927 1.3921 5.44865 1.11517 5.89772 1.11517H8.57714C9.02619 1.11517 9.32559 1.3921 9.32559 1.81871V3.42037H10.5156V1.74387C10.5156 0.658628 9.81207 0 8.65946 0H5.81538C4.66278 0 3.95925 0.658628 3.95925 1.74387V3.42037ZM0.56133 4.01913H13.936C14.2428 4.01913 14.4898 3.75717 14.4898 3.45031C14.4898 3.14345 14.2428 2.88898 13.936 2.88898H0.56133C0.261954 2.88898 0 3.14345 0 3.45031C0 3.76466 0.261954 4.01913 0.56133 4.01913ZM3.81705 16.6678H10.6803C11.7505 16.6678 12.469 15.9717 12.5214 14.9014L13.0453 3.86196H1.44449L1.97588 14.909C2.02827 15.9792 2.73181 16.6678 3.81705 16.6678Z" fill="#DC3545"/>
              </svg>
            </div>
            <div class="d-flex">
              <div class="flex-shrink-0 h-auto" @click="detail(room_rate)" style="width: 70px;">
                <img
                  :src="$isNotEmpty(room_rate.room_rate.room_type.image) ? room_rate.room_rate.room_type.image[0].image_url : getMerchant.image_url" 
                  class="img-fit rounded-3 cursor-pointer">
              </div>
  
              <div class="w-100 pl-2-5">
                <div class="w-100 mb-1" @click="detail(room_rate)">
                  <div class="d-flex align-items-center cursor-pointer lh-1 mb-1" >
                    <p v-if="isRoomDiscount(room_rate)" class="mb-0 text-12 text-subcolor font-lato-regular text-line-through mr-2">{{$formatCurrency(calculateSubTotal(room_rate,false))}}</p>
                    <p class="mb-0 text-14 font-lato cursor-pointer text-orange">{{$formatCurrency(calculateSubTotal(room_rate))}}</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="body-3 mb-0 flex-shrink-0" style="width: 40px;">Qty</span>  
                    <span class="body-3-3-2 mb-0">: {{room_rate.qty}} {{$t('hotel.unit-type.'+room_rate.room_rate.room_type.type+'.unit')}}</span>  
                  </div>
                  <div class="d-flex align-items-top">
                    <span class="body-3 mb-0 flex-shrink-0" style="width: 40px;">Guest</span>  
                    <span class="body-3-3-2 mb-0">: {{ filter_guest(room_rate.guest) }}</span>  
                  </div>
                </div>
                <p class="mb-0 font-lato ls-0-25 text-14 text-green cursor-pointer underline" @click="onBack('adjustPax',{
                    room_rate,
                    valdiateAgeChild: $v.cartRoomList.$each[rr_index].$error
                  })">
                  Guest Details
                </p>
              </div>
            </div>
            <p 
              v-if="$v.cartRoomList.$each[rr_index].$error" 
              class="w-100 body-3 text-danger mt-2 mb-0" 
              @click="onBack('adjustPax',{
                room_rate,
                valdiateAgeChild: $v.cartRoomList.$each[rr_index].$error
              })">
              Please provide the child’s age
            </p>
          </div>
        </template>
        <div v-if="isUnderSearchPax()" class="w-100 px-3 mb-3">
          <div
            class="w-100 p-3 text-center border rounded"
            style="
              background-color: rgb(255, 246, 243);
              border-color: rgb(254, 207, 184) !important;
            ">
            <p class="mb-0 body-2-1">{{ isUnderSearchPax() }}</p>
          </div>
        </div>

        <!-- ADDITIONAL SERVICE -->
        <div
          class="border-t-form px-3 pt-3"
          v-if="total_additional_service > 0">
          <ProductCart page="CART-ADDITIONAL" @register-ref="setPrimaryRef" :hide-remove="false" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { formatCurrency, formatDate } from '@/utils/index.js';
import { validationMixin } from "vuelidate";
const { helpers } = require("vuelidate/lib/validators");
import ProductCart from '../additionalService/ProductCart.vue';
import PerRoomCart from '../PerRoomCart.vue';

const skipIfNoGuest = (type, validatorFn) =>
    helpers.withParams({ type: "skipIfNoGuest" }, function (value, parentVm) {
      const totalGuest = 
        (parentVm.included && parentVm.included[type] ? parentVm.included[type] : 0) +
        (parentVm.extra && parentVm.extra[type] ? parentVm.extra[type] : 0)
        
      if (totalGuest === 0) {
        return true
      }
      return validatorFn(value)
    })

export default {
  components: {
    ProductCart,
    PerRoomCart
  },
  computed: {
    isMerchantMaldiveOhip(){
      const { country = 'Indonesia', cm_reference = '' } = this.getMerchant();
      
      return country === 'Maldives' && cm_reference === 'OHIP';
    },
    total_additional_service() {
      let total =
        this.getBeAddtServiceSubTotal() + this.$totalAddtServiceModule();
      return total;
    },
    totalNight(){
      const { check_in, check_out } = this.getBeFilter().date;
      return this.$countDays(check_in, check_out)
    },
    cartRoomList(){
      return JSON.parse(JSON.stringify(this.getBeCart().room_rate_details));
    }
  },
  mixins: [validationMixin],
  validations: {
    cartRoomList: {
      $each: {
        guest: {
          $each: {
            age:{
              requiredChildAge: skipIfNoGuest('child',
                v => v !== undefined
              ),
              requiredInfantAge: skipIfNoGuest('infant',
                v => v !== undefined
              ),
              child:{
                $each: {
                  requiredArray: skipIfNoGuest('child',
                    v => Array.isArray(v)
                  ),
                  notEmpty: skipIfNoGuest('child',
                    v => Array.isArray(v) && v.length > 0 && v.every(val => val !== "")
                  )
                }
              },
              infant:{
                $each: {
                  requiredArray: skipIfNoGuest('infant',
                    v => Array.isArray(v)
                  ),
                  notEmpty: skipIfNoGuest('infant',
                    v => Array.isArray(v) && v.length > 0 && v.every(val => val !== "")
                  )
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapGetters([
      'getMerchant',
      'getBeCart',
      'getBeFilter',
      'getCurrentLanguage',
      'isUnderSearchPax',
      'getBeAddtServiceSubTotal',
    ]),
    ...mapMutations(['beRemoveRoomRate', 'changeBeRoomAvbl']),
    setPrimaryRef(ref) {
      this.$emit('register-ref', ref)
    },
    setTransportRouteRef(ref){
      this.$emit('register-tr-ref', ref)
    },
    formatDate(date) {
      return formatDate(date);
    },
    formatCurrency(value) {
      return formatCurrency(value);
    },
    calculateSubTotal(data, with_discount = true) {
      let total = 0;
      for (let i = 0; i < data.qty; i++) {
        for (let date of data.room_rate.dates) {
          let total_extra = {
            adult: data.guest[i].extra.adult * date.extra_guest.adult.amount,
            child: data.guest[i].extra.child * date.extra_guest.child.amount,
            infant: data.guest[i].extra.infant * date.extra_guest.infant.amount,
          };
          let total_extra_price =
            total_extra.adult + total_extra.child + total_extra.infant;
          let base_price = with_discount
            ? date.price + date.promotion_price
            : date.price;
          if (total_extra_price > 0) {
            total += base_price + total_extra_price;
          } else {
            total += base_price;
          }
        }
      }
      return total;
    },
    isRoomDiscount(data) {
      let total = 0;
      for (let date of data.room_rate.dates) {
        total += date.promotion_price;
      }
      return total < 0;
    },
    detail(data) {
      this.$emit('detail', data);
    },
    onBack(type, data) {
      this.$emit(type, data);
    },
    removeRoomRate(cart) {
      this.beRemoveRoomRate(cart.room_rate.id);
      let roomtype_params = {
        id: cart.room_rate.room_type.id,
        rr_id: cart.room_rate.id,
        qty: cart.qty,
        action: 'inc',
        is_virtual: cart.room_rate.room_type.is_virtual,
        availability_affected: cart.room_rate.room_type.availability_affected,
      };
      this.changeBeRoomAvbl(roomtype_params);
    },
    filter_guest(room_rate) {
      let total_guest = {
        adult: 0,
        child: 0,
        infant: 0,
        extra: 0,
      };
      room_rate.forEach((item) => {
        total_guest.adult += item.included.adult;
        total_guest.child += item.included.child;
        total_guest.infant += item.included.infant;
        total_guest.extra +=
          item.extra.adult + item.extra.child + item.extra.infant;
      });
      let container = [];
      if (total_guest.adult > 0) {
        container.push(
          total_guest.adult + ' ' + this.$t('hotel.adults.adults')
        );
      }
      if (total_guest.child > 0) {
        container.push(
          total_guest.child + ' ' + this.$t('hotel.children.children')
        );
      }
      if (total_guest.infant > 0) {
        container.push(
          total_guest.infant + ' ' + this.$t('hotel.infants.infants')
        );
      }
      if (total_guest.extra > 0) {
        container.push(
          `${total_guest.extra} ${this.$pluralWord(
            total_guest.extra,
            this.$t('hotel.extra-guest')
          )}`
        );
      }

      let display = '';
      for (let i = 0; i < container.length; i++) {
        if (i + 1 == container.length) {
          display += container[i];
        } else {
          display += container[i] + ', ';
        }
      }

      return display;
    },
    validateChildAge(){
      this.$v.$reset();
      this.$v.$touch();
      if (this.$v.$invalid) {
        const indexNotValid = Object.values(this.$v.cartRoomList.$each.$iter).findIndex(parent => parent.$error);
        if(indexNotValid != -1){
          let roomRateSelected = this.cartRoomList[indexNotValid];

          if(this.isMerchantMaldiveOhip){
            const roomSelectedValidation = this.$v.cartRoomList.$each.$iter[indexNotValid];
            const indexNotValidChild = Object.values(roomSelectedValidation.guest.$each.$iter).findIndex(child => child.$error);
            if(indexNotValidChild !== -1) Object.assign(roomRateSelected, { guestIndex: indexNotValidChild})
          }

          this.onBack('adjustPax',{
            room_rate: roomRateSelected,
            valdiateAgeChild: true
          })
        }
        return false
      }
      return true
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/mobile/cartRoomRateDetail.vue